(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .config(routes);

  /* ngInject */
  function routes($stateProvider) {
    $stateProvider
      .state('application.compliance_services.cms_list_categories', {
        url: '/cms/categories',
        views: {
          '@application.compliance_services': {
            templateUrl: '/templates/compliance_services/cms/categories/cms-list-categories.html',
            controller: 'CmsListCategoriesController',
            controllerAs: 'vm'
          }
        }
      })

      .state('application.compliance_services.cms_new_category', {
        url: '/cms/categories/new',
        views: {
          '@application.compliance_services': {
            templateUrl: '/templates/compliance_services/cms/categories/cms-new-category.html',
            controller: 'CmsNewCategoryController',
            controllerAs: 'vm'
          }
        }
      })

      .state('application.compliance_services.cms_edit_category', {
        url: '/cms/categories/:id',
        views: {
          '@application.compliance_services': {
            templateUrl: '/templates/compliance_services/cms/categories/cms-edit-category.html',
            controller: 'CmsEditCategoryController',
            controllerAs: 'vm'
          }
        }
      })
    ;
  }
})();
